import '@/styles/global.css';

import * as Sentry from '@sentry/react';
import { NuqsAdapter } from 'nuqs/adapters/react';

import { Toaster } from '@crehana/compass.ui/v3/toaster';
import { SPALayout } from '@crehana/layouts/spa/layout-with-centralized';

import { AddBaseFunctionality } from '@/shared/components/add-base-functionality';
import { Outlet, useParams } from '@/shared/modern-router';

import { HanaFloatingChatLazy } from '@crehana/hana-ai/floating-chat';

const App = () => {
  const { slug } = useParams();

  return (
    <SPALayout sentryInstance={Sentry} organizationSlug={slug as string}>
      <NuqsAdapter>
        <Outlet />
        <HanaFloatingChatLazy />
      </NuqsAdapter>
      <AddBaseFunctionality />
      {/* tw-z-[16100000] overrides the Toaster's hardcoded tw-z-[9999] via tailwind-merge,
          placing it above tw-z-dialog (16000001) used by Sheet/Drawer */}
      <Toaster className="tw-z-[16100000]" />
    </SPALayout>
  );
};

export default App;
